import * as React from 'react';
import { TrackingFunnelProvider, AppErrorProvider, ErrorNamespaceProvider, BlockingErrorBoundary } from '@edreamsodigeo/frontend-core';
import { Page as FirstLogin } from './pages/firstLogin';
import { Page as PasswordlessLogin } from './pages/passwordlessLogin';
import { Page as Reauthentication } from './pages/reauthentication';
import { TranslationsPageProvider } from './components/TranslationsPageProvider';
export const AuthenticationFunnel = () => {
  return /*#__PURE__*/React.createElement(AppErrorProvider, {
    logService: "/frontend-api"
  }, /*#__PURE__*/React.createElement(ErrorNamespaceProvider, {
    namespace: "shell_funnel_authentication"
  }, /*#__PURE__*/React.createElement(BlockingErrorBoundary, {
    name: "funnel_authentication"
  }, /*#__PURE__*/React.createElement(TrackingFunnelProvider, null, /*#__PURE__*/React.createElement(TranslationsPageProvider, null, /*#__PURE__*/React.createElement(FirstLogin, null), /*#__PURE__*/React.createElement(PasswordlessLogin, null), /*#__PURE__*/React.createElement(Reauthentication, null))))));
};